import type { AdminAbility } from '@repo/sdk/backoffice-abilities'
import { useSuspenseQuery } from '@tanstack/react-query'
import { adminSessionQueryOptions } from '@/lib/query-options'
import {
	hasAdminAbility,
	type PermissionCheckOptions
} from '@/modules/permissions/lib/has-admin-ability'

type CanFn = (
	abilities: AdminAbility[],
	options?: PermissionCheckOptions
) => boolean

export function useCan(): CanFn
export function useCan(
	abilities: AdminAbility[],
	options?: PermissionCheckOptions
): boolean
export function useCan(
	abilities?: AdminAbility[],
	options?: PermissionCheckOptions
): boolean | CanFn {
	const { data } = useSuspenseQuery(adminSessionQueryOptions())
	const granted = data.sessionType === 'authenticated' ? data.abilities : null

	if (abilities === undefined) {
		return (a, o) => hasAdminAbility(granted, a, o)
	}

	return hasAdminAbility(granted, abilities, options)
}
